import { HttpClient } from '@angular/common/http';
import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { AuthService } from 'src/app/services/auth.service';
import { UsersService } from 'src/app/services/users.service';
import {default as data} from 'src/assets/data/countries.json';
import {default as codes } from 'src/assets/data/country-codes.json';

@Component({
  selector: 'app-account',
  templateUrl: './account.component.html',
  styleUrls: ['./account.component.scss']
})
export class AccountComponent implements OnInit {

  public states: any=[];
  public countries: any = data;
  public gender: any = [{name:'Male', label: 'M'}, {name:'Female',label: 'F'}, {name: 'Others', label: 'O'}];
  public title: any = ['Mr', 'Ms', 'Mrs'];
  public updateProfileForm: FormGroup;
  public publicKey: any;
  public submitted: boolean = false;
  public currentPassword:string;
  public newPassword:string;
  public confirmPassword:string = '';
  public isNotMatched:boolean = false;
  public isAgree:boolean = false;
  public isPassword:boolean = false;
  public userId:any;
  @Output() selectedTab:EventEmitter<string> = new EventEmitter();

  constructor(private authService: AuthService, private toastrService: ToastrService, private usersService: UsersService, private router: Router, private http: HttpClient) { }

  ngOnInit(): void {
    this.userId = JSON.parse(sessionStorage.getItem('logged-in-user'))._id;
    this.updateProfileForm = new FormGroup({
      title: new FormControl('', Validators.required),
      firstName: new FormControl('', Validators.required),
      lastName: new FormControl('', Validators.required),
      dob: new FormControl('', Validators.required),
      countryCode: new FormControl('', Validators.required),
      phone: new FormControl('', Validators.required),
      qualification: new FormControl('', Validators.required),
      state: new FormControl('', Validators.required),
      country: new FormControl('', Validators.required),
      pincode: new FormControl('', Validators.required),
      address: new FormControl('', Validators.required),
      email: new FormControl('', Validators.required),
      institution: new FormControl('', Validators.required),
      gender: new FormControl('', Validators.required)
    })
    let user = {};
    this.usersService.getUserDetails(this.userId).subscribe(
      (res: any) => {
        user['firstName'] = res.firstName;
        user['lastName'] = res.lastName;
        user['dob'] = res.dob;
        user['phone'] = res.phone;
        user['qualification'] = res.qualification;
        user['email'] = res.email;
        user['institution'] = res.institution;
        user['gender'] = res.gender;
        user['pincode'] = res.pincode;
        user['state'] = res.state;
        user['country'] = res.country;
        user['title'] = res.title;
        user['address'] = res.address;
        this.updateProfileForm.patchValue(user);
        this.onSelectCountry();
      }
    )
  }


  onSelectCountry(){
    for(let i=0;i<data['data'].length;i++){
      if(data.data[i].name == this.updateProfileForm.get('country').value){
        this.states = data.data[i].states;
        break;
      }
    }
    for(let i=0;i<codes.length;i++){
      if(codes[i].name == this.updateProfileForm.get('country').value){
        this.updateProfileForm.get('countryCode').setValue(codes[i].dial_code);
        break;
      }
    }
  }

  onClickPassword(){
    this.isPassword = true;
  }

  async onClickUpdate(){
    if(this.updateProfileForm.valid && !this.isPassword){
      this.usersService.updateUserDetails(this.userId, this.updateProfileForm.value)
      .subscribe(
        (res)=>{
          this.toastrService.success('User Details updated!')
          this.selectedTab.emit('dashboard');
        }
      )
    }

    else {
      if(this.newPassword != this.confirmPassword)
        this.toastrService.error('New password and confirm password do not match');
      else {
        let response = await this.authService.getPublicKey().toPromise();
        let payload = this.authService.encrypt({
          newPassword: this.newPassword,
          currentPassword: this.currentPassword
        }, response['key']);
        this.usersService.resetPassword(this.userId, {credentials: payload}).subscribe((response) => {
          this.toastrService.success(response['description'])
        }, ({error}) => {
          this.toastrService.error(error.message)
        })
      }
    }
  }


}
